export default __webpack_public_path__ + "static/media/assign1.60608724.mp3";